// UCR item 5: log out after 30 minutes without user activity (mouse, keyboard, touch, scroll).
// The last activity time is kept in localStorage, so activity in any OneSYS tab keeps all tabs logged in.
// Only real user input counts: background API calls and timers must not call markActive().
export const IDLE_LIMIT_MS = 30 * 60 * 1000
const KEY = 'onesys.lastActivity'

let lastLocal = Date.now()

export const markActive = () => {
  lastLocal = Date.now()
  try { localStorage.setItem(KEY, String(lastLocal)) } catch (e) { /* private mode: per-tab only */ }
}

export const lastActivity = () => {
  let shared = 0
  try { shared = parseInt(localStorage.getItem(KEY), 10) || 0 } catch (e) { /* ignore */ }
  return Math.max(shared, lastLocal)
}

export const isIdle = () => Date.now() - lastActivity() > IDLE_LIMIT_MS

let throttle = 0
const onActivity = () => {
  const now = Date.now()
  if (now - throttle > 15000) { throttle = now; markActive() } // write at most every 15 s
}

export const startIdleTracking = () => {
  markActive()
  ;['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach((ev) =>
    window.addEventListener(ev, onActivity, { passive: true, capture: true }))
}
